import { memo } from "react";
import { cn } from "@discovery/classnames";
import { useEffect, useState } from "@discovery/common-dplus/lib/hooks";
import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useWindowSize } from "../../../../../utils/hooks";
import { getIsMobile } from "../../../../../utils/isMobile";
import { Icon, Icons } from "../../../../atoms/icon";
import { Link } from "../../../../atoms/link";
import { PlaceholderImage, HeightVariant, } from "../../../../atoms/placeholder-image";
import * as styles from "./styles.css";
import Strings from "../../../../../utils/hardcoded.json";
import { useUser } from "../../../../../utils/hooks";
import OverlayD from "./_components/overlayD";
const AgeContraintTag = () => (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints }));
const PremiumIcon = ({ index }) => (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: cn(styles.topShowPremiumIcon, {
        [styles.tenthShow]: index >= 10,
    }) }));
const TopShowCardImage = ({ image, index, }) => {
    return (React.createElement("div", { className: styles.showWrapper },
        React.createElement("div", { className: cn(styles.topShowIndex, {
                [styles.numberedRail]: index >= 10,
            }) }, index),
        React.createElement("div", null,
            React.createElement(PlaceholderImage, { variant: HeightVariant.TopShows })),
        image && (React.createElement(SonicImage, { image: image, quality: 75, imageSizes: {
                default: [300, "px"],
                maxWidthMediaQueries: [
                    [699, "px", 120, "px"],
                    [1023, "px", 300, "px"],
                ],
            }, fallbackImageSize: { width: 300 }, className: styles.topShowImages }))));
};
const NewEpisodesTag = ({ isNewEpisodeM = M.empty(), title, index, }) => {
    return (React.createElement(RenderMaybe, null, M.map((isNewEpisode) => {
        return (React.createElement("div", { className: cn(styles.newEpisodeContainer, {
                [styles.tenthNewTag]: index >= 10,
            }) }, isNewEpisode && React.createElement("span", { className: styles.Episodes }, title)));
    }, isNewEpisodeM)));
};
const PlayerIcon = () => (React.createElement("div", { className: styles.PlayIcon },
    React.createElement(Icon, { type: Icons.PlayIcon, className: styles.playIcon, color: "black" })));
const TopShowCardM = ({ id, route, videoType, seasonNumberM = M.empty(), index, isContentAccessible, image, isNewEpisodeM, isPlayable, isPremium, }) => {
    const vType = M.fromMaybe(videoType, "");
    const seasonId = M.fromMaybe(seasonNumberM, 0);
    const checkSeasonId = seasonId > 0 ? `&seasonId=${seasonId}` : "";
    const checkVideoType = vType ? `?type=${vType}` : "";
    return (React.createElement("div", { className: styles.showCard },
        React.createElement("div", { className: cn(styles.topShowcardContainer, {
                [styles.numberedRailCard]: index >= 10,
            }), id: "#" + id },
            isContentAccessible && React.createElement(AgeContraintTag, null),
            isPremium && React.createElement(PremiumIcon, { index: index }),
            isContentAccessible ? (React.createElement(TopShowCardImage, { image: image, index: index })) : (React.createElement(Link, { href: route + `${checkVideoType}${checkSeasonId}` },
                React.createElement(TopShowCardImage, { image: image, index: index }))),
            React.createElement(NewEpisodesTag, { isNewEpisodeM: isNewEpisodeM, index: index, title: Strings.NEW }),
            isPlayable && React.createElement(PlayerIcon, null))));
};
const TopShowCardD = ({ name, id, descriptionM = M.empty(), category = "", index, route, videoType = M.empty(), seasonNumberM = M.empty(), isFavorite, image, isContentAccessible, isPlayable, isNewEpisodeM, webAuthRedirectionUrl, read, genre, isPremium, contentGenre, }) => {
    const type = M.fromMaybe(videoType, "");
    const seasonNumber = M.fromMaybe(seasonNumberM, 0);
    const seasonId = seasonNumber > 0 ? `&seasonId=${seasonNumber}` : "";
    const videoQueryType = type ? `?type=${type}` : "";
    return (React.createElement(Link, { href: route + `${videoQueryType}${seasonId}` },
        React.createElement("div", { className: styles.showCard },
            React.createElement("div", { className: cn(styles.topShowcardContainer, {
                    [styles.numberedRailCard]: index >= 10,
                    [styles.hoverable]: !getIsMobile(),
                }), id: "#" + id },
                React.createElement(OverlayD, { descriptionM: descriptionM, isFavorite: isFavorite, read: read, category: category, id: id, webAuthRedirectionUrl: webAuthRedirectionUrl, index: index, route: route, showGenre: genre, name: name, contentGenre: contentGenre }),
                isContentAccessible && React.createElement(AgeContraintTag, null),
                isPremium && React.createElement(PremiumIcon, { index: index }),
                React.createElement(TopShowCardImage, { image: image, index: index }),
                React.createElement(NewEpisodesTag, { isNewEpisodeM: isNewEpisodeM, index: index, title: Strings.NEW_EPISODES }),
                isPlayable && React.createElement(PlayerIcon, null)))));
};
export const TopShowCard = memo(({ name, id, descriptionM = M.empty(), category = "", index, route, videoType = M.empty(), seasonNumberM = M.empty(), packages, image, isNewEpisodeM = M.empty(), isPlayable, webAuthRedirectionUrl, ageConstraint = 0, minimumAgeM = M.empty(), isFavoriteM = M.empty(), read, genre, packagesM, contentGenre, }) => {
    const { premiumPackagesM } = useUser();
    const [width] = useWindowSize();
    const [isContentAccessible, setisContentAccessible] = useState(true);
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const isPremium = premiumPackages.includes(packages);
    const isFavorite = M.fromMaybe(isFavoriteM, false);
    useEffect(() => {
        const minimumAge = M.fromMaybe(minimumAgeM, 0);
        const isContentAccessible = minimumAge > ageConstraint;
        setisContentAccessible(isContentAccessible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return width && width <= 699 ? (React.createElement(TopShowCardM, { id: id, route: route, videoType: videoType, seasonNumberM: seasonNumberM, index: index, isContentAccessible: isContentAccessible, image: image, isNewEpisodeM: isNewEpisodeM, isPlayable: isPlayable, isPremium: isPremium })) : (React.createElement(TopShowCardD, { name: name, id: id, descriptionM: descriptionM, category: category, index: index, route: route, videoType: videoType, seasonNumberM: seasonNumberM, isFavorite: isFavorite, image: image, isContentAccessible: isContentAccessible, isPlayable: isPlayable, isNewEpisodeM: isNewEpisodeM, webAuthRedirectionUrl: webAuthRedirectionUrl, read: read, genre: genre, isPremium: isPremium, packages: packages, packagesM: packagesM, contentGenre: contentGenre }));
});

